import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';

import MicromodalContent from 'ember-micromodal/components/micromodal/content';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    onClose: () => void;
  };
  Blocks: { default: []; header: [] };
}

const FullscreenModal: TOC<Signature> = <template>
  <MicromodalContent
    @targetModal='legacy-modal'
    @labelElement=''
    @onOverlayClick={{@onClose}}
    @config={{hash disableFocus=true}}
  >
    {{yield to='header'}}
    <div ...attributes>{{yield}}</div>
  </MicromodalContent>
</template>;

export default FullscreenModal;
